
import { defineComponent, PropType } from "vue";
// components
import EmployeeTableRow from "./EmployeeTableRow.vue";
import TableBase from "@/components/table/TableBase.vue";
import TableHeaderItem from "@/components/table/TableHeaderItem.vue";
// other
import { Users } from "@/graphql/types";

export default defineComponent({
  name: "EmployeeTable",
  components: {
    EmployeeTableRow,
    TableBase,
    TableHeaderItem
  },
  props: {
    selectable: { type: Boolean, default: false },
    employees: { type: Object as PropType<Users[]>, required: true },
    selectedIdList: {
      required: false,
      default: () => [] // error if instead "type: Array"
    }
  },
  emits: ["selected"],
  setup(props, context) {
    // pass through event
    const onSelected = (employeeId: string) => {
      context.emit("selected", employeeId);
    };

    return { onSelected };
  }
});
